<div class="group-management">
  <div class="grid">
    <div class="col-12">
      <p-table #groupMgmListGrp id="groupManagement" #pdt_group_management (onRowSelect)="handleGroupSelection($event.data)"
               [alwaysShowPaginator]="false"
               [columns]="groupColumns" [paginatorPosition]="'top'" [paginator]="true" [rows]="pageRows"
               [sortField]="groupSortField" [metaKeySelection]="false"
               [value]="groupList" selectionMode="single" [rowHover]="true" [globalFilterFields]="['sGrpUserLabel', 'filterContent']">
        <ng-template pTemplate="caption">
          <div class="flex">
            <!--<button pButton [label]="'COMMON.CLEAR' | translate" class="p-button-outlined" icon="pi pi-filter-slash" (click)="clear(groupMgmListGrp)"></button>-->
            <span class="p-input-icon-right group-filter">
                <input pInputText type="text" (input)="filter(groupMgmListGrp, $event.target)" [placeholder]="'COMMON.KEYWORD' | translate" />
                <i class="pi pi-search"></i>
            </span>
          </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field">
              {{ col.header }}
            </th>
          </tr>
          <!--<tr>
            <th *ngFor="let col of columns">
              <p-columnFilter type="text" field="col.field"></p-columnFilter>
            </th>
          </tr>-->
        </ng-template>
        <ng-template pTemplate="body" let-group let-columns="columns">
          <tr [pSelectableRow]="group">
            <td *ngFor="let column of columns">
              {{ group[column.field] }}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'FOLDS.LIST_COMPONENT.EMPTY_MESSAGE' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="col-12">
      <div class="col-4">
        <button pButton type="button" [label]="'GROUP_MANAGEMENT.COMPONENT.CREATE_GROUP' | translate"
                [icon]="'fa fa-plus'" class="p-button-warning"
                (click)="createNewGroup()"></button>
      </div>
      <div class="col-4">
        <button *ngIf="selectedGroup && !newGroup" pButton type="button" [label]="'GROUP_MANAGEMENT.COMPONENT.GROUP_CHAINS' | translate"
                [icon]="'fa fa-cog'" class="p-button-warning"
                (click)="showGroupChainModal()"></button>
      </div>
      <div class="col-4">
        <button pButton type="button" [label]="'GROUP_MANAGEMENT.COMPONENT.IMPORT_USERS' | translate"
                [icon]="'fa fa-plus'" class="p-button-warning" style="float: right;"
                (click)="showImportUsersModal()"></button>
      </div>
    </div>

    <div class="col-12" *ngIf="selectedGroup">
      <div *ngIf="!editGroup">
        <div class="grid">
          <p-fieldset [legend]="'GROUP_MANAGEMENT.COMPONENT.GROUP_DETAILS_HEADER' | translate">
            <div class="col-12">
              <div class="col-5">{{groupIdColumnLabel}}</div>
              <div class="col-7">{{selectedGroup.sGrpUserID}}</div>
            </div>
            <div class="col-12">
              <div class="col-5">{{'COMMON.ENABLED' | translate}}</div>
              <div
                class="col-7">{{selectedGroup.bGrpUserActive ? ('COMMON.YES' | translate) : ('COMMON.NO' |translate)}}</div>
            </div>
            <div class="col-12">
              <div class="col-5">{{groupNameColumnLabel}}</div>
              <div class="col-7">{{selectedGroup.sGrpUserLabel}}</div>
            </div>
            <div class="col-12">
              <div class="col-5">{{'GROUP_MANAGEMENT.COMPONENT.GROUP_EMAIL_LABEL' | translate}}</div>
              <div class="col-7">{{selectedGroup.sCustomerGrpEmail}}</div>
            </div>
            <div class="col-12">
              <div class="col-5">{{'GROUP_MANAGEMENT.COMPONENT.GROUP_ALARM_EMAIL_LABEL' | translate}}</div>
              <div class="col-7">{{selectedGroup.sAlarmeEmail}}</div>
            </div>
            <div class="col-12">
              <div class="col-5">{{'GROUP_MANAGEMENT.COMPONENT.GROUP_DEFAULT_CHAIN_LABEL' | translate}}</div>
              <div class="col-7">{{selectedGroup.sTrtChainName}}</div>
            </div>
            <div class="col-12">
              <div class="col-5">{{'GROUP_MANAGEMENT.COMPONENT.GROUP_ANALYTIC_CODE_LABEL' | translate}}</div>
              <div class="col-7">{{selectedGroup.sAnalytiqueID}}</div>
            </div>
            <div class="col-12">
              <div class="col-5">{{'COMMON.LANGUAGES.LANGUAGE' | translate}}</div>
              <div class="col-7">{{languages[selectedGroup.sLangId]}}</div>
            </div>
            <div class="col-12">
              <div class="col-4">
                <button pButton type="button"
                        [label]="'GROUP_MANAGEMENT.COMPONENT.GROUP_ADDRESS_EDIT_LABEL' | translate"
                        [icon]="'fa fa-pencil'" class="p-button-warning"
                        (click)="editAddress()"></button>
              </div>
              <div class="col-4"></div>
              <div class="col-4  align-right">
                <button pButton type="button" [label]="'COMMON.EDIT' | translate"
                        [icon]="'fa fa-pencil'" class="p-button-warning"
                        (click)="editSelectedGroup()"></button>
              </div>
            </div>
          </p-fieldset>
        </div>
      </div>
      <div *ngIf="editGroup">
        <div class="grid">
          <p-fieldset [legend]="'GROUP_MANAGEMENT.COMPONENT.GROUP_DETAILS_HEADER' | translate">
            <div class="col-12">
              <div class="col-5">{{groupIdColumnLabel}}</div>
              <div class="col-7" *ngIf="!newGroup">{{editGroup.sGrpUserID}}</div>
              <div class="col-7" *ngIf="newGroup">
                <input #sGrpUserID pInputText [(ngModel)]="editGroup.sGrpUserID"/>
              </div>
            </div>
            <div class="col-12" *ngIf="duplicateId">
              <div class="col-5"></div>
              <div class="col-7 ">
                <div class="error">{{duplicateIdLabel}}</div>
              </div>
            </div>
            <div class="col-12">
              <div class="col-5">{{'COMMON.ENABLED' | translate}}</div>
              <div class="col-7">
                <p-checkbox [binary]="true" #bGrpUserActive [(ngModel)]="editGroup.bGrpUserActive"></p-checkbox>
              </div>
            </div>
            <div class="col-12">
              <div class="col-5">{{groupNameColumnLabel}}</div>
              <div class="col-7"><input pInputText #sGrpUserLabel [(ngModel)]="editGroup.sGrpUserLabel"></div>
            </div>
            <div class="col-12">
              <div class="col-5">{{'GROUP_MANAGEMENT.COMPONENT.GROUP_EMAIL_LABEL' | translate}}</div>
              <div class="col-7"><input pInputText #sCustomerGrpEmail [(ngModel)]="editGroup.sCustomerGrpEmail"></div>
            </div>
            <div class="col-12">
              <div class="col-5">{{'GROUP_MANAGEMENT.COMPONENT.GROUP_ALARM_EMAIL_LABEL' | translate}}</div>
              <div class="col-7"><input pInputText #sAlarmeEmail [(ngModel)]="editGroup.sAlarmeEmail"></div>
            </div>
            <div class="col-12">
              <div class="col-5">{{'GROUP_MANAGEMENT.COMPONENT.GROUP_DEFAULT_CHAIN_LABEL' | translate}}</div>
              <div class="col-7">
                <p-dropdown [filter]="true" [options]="trtChainList"
                            [(ngModel)]="selectedGroup.sTrtChainName"></p-dropdown>
              </div>
            </div>
            <div class="col-12">
              <div class="col-5">{{'GROUP_MANAGEMENT.COMPONENT.GROUP_ANALYTIC_CODE_LABEL' | translate}}</div>
              <div class="col-7"><input pInputText [(ngModel)]="editGroup.sAnalytiqueID"></div>
            </div>
            <div class="col-12">
              <div class="col-5">{{'COMMON.LANGUAGES.LANGUAGE' | translate}}</div>
              <div class="col-7">
                <p-dropdown [options]="locales" #sLangId [(ngModel)]="editGroup.sLangId" [style]="{'width':'150px'}">
                </p-dropdown>
              </div>
            </div>
            <div class="col-12 align-right">
              <div class="col-4 align-left">
                <button pButton type="button" [label]="'COMMON.CANCEL' | translate"
                        [icon]="'fa fa-times'" class="p-button-warning"
                        (click)="cancelEditGroup()"></button>
              </div>
              <div class="col-4"></div>
              <div class="col-4 align-right">
                <button pButton type="button" [label]="'COMMON.SAVE' | translate"
                        [icon]="'fa fa-save'" class="p-button-warning"
                        (click)="saveGroup()"></button>
              </div>
            </div>
          </p-fieldset>
        </div>
      </div>
    </div>
    <div *ngIf="showLockFailureMessage" class="error">
      {{'GROUP_MANAGEMENT.COMPONENT.GROUP_LOCK_MESSAGE' | translate}}
    </div>
  </div>
</div>
<p-dialog *ngIf="editGroupAddress" [(visible)]="editGroupAddress" [styleClass]="'adressModal'" [appendTo]="'body'"
          [header]="'FOLD.ACTION_COMPONENT.ADD_MODAL_TITLE' | translate"
          [draggable]="false"
          [closable]="true"
          [resizable]="false"
          [modal]="true" [closeOnEscape]="false">
  <app-group-address [group]="selectedGroup" [address]="addressObj.addInfo"
                     (visible)="handleAddressClose($event)"></app-group-address>
</p-dialog>
<div class="import-user-modal" *ngIf="showImportUsers">
  <p-dialog [(visible)]="showImportUsers"
            [header]="('GROUP_MANAGEMENT.COMPONENT.IMPORT_USERS_TITLE' | translate)"
            [draggable]="false"
            [closable]="true"
            [resizable]="false"
            [modal]="true" [closeOnEscape]="false">
    <app-import-users [groups]="groupList" [customerId]=""></app-import-users>
  </p-dialog>
</div>
<div class="group-chains-modal" *ngIf="showGroupChains">
  <p-dialog [(visible)]="showGroupChains"
            [header]="('GROUP_MANAGEMENT.COMPONENT.GROUP_CHAINS_TITLE' | translate: {group: selectedGroup.sGrpUserID})"
            [draggable]="true"
            [closable]="true"
            [resizable]="false"
            [modal]="true" [closeOnEscape]="true">
    <app-group-chains [groupId]="selectedGroup.sGrpUserID" (configSaved)="handleConfigSaved($event)"></app-group-chains>
  </p-dialog>
</div>
